export type SupportPhoneCountry = 'DK' | 'DE' | 'FR' | 'NL'

export const supportPhone: Record<SupportPhoneCountry, string> = {
  FR: '+33 1 89 74 42 60',
  DE: '+49 30 31197840',
  DK: '+45 89 87 87 00',
  NL: '+31 85 1073635',
}

const defaultSupportPhoneCountry: SupportPhoneCountry = 'DK'

const isSupportPhoneCountry = (countryId: string): countryId is SupportPhoneCountry => countryId in supportPhone

export const getSupportPhone = (countryId?: string): { countryId: SupportPhoneCountry; number: string } => {
  const resolvedCountryId = countryId && isSupportPhoneCountry(countryId) ? countryId : defaultSupportPhoneCountry

  return { countryId: resolvedCountryId, number: supportPhone[resolvedCountryId] }
}
